export const initializeLogger = () => {
  /* eslint no-undef: "off"*/
  require("js-logger").useDefaults();
};
